import React from "react";

const Aim = () => {
  return (
    <div className="w-screen" id="our-aim">
      <section class="bg-white mx-auto ">
        <div class="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
          <div class="max-w-screen-lg text-gray-500 sm:text-lg mx-auto ">
            <h2 class="mb-4 text-4xl tracking-tight font-extrabold text-gray-900 text-center ">
              OUR AIM
            </h2>
            <p class="mb-4 font-light text-center">
              Our goal is to prepare postgraduate Physics candidates for all
              types of competitive exams in physics by building a strong
              academic foundation through quality teaching, personalized
              attention, and cultivating a competitive attitude
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Aim;
